export default __webpack_public_path__ + "static/media/screen5.ec027143.png";